/**
 * Created by Ning Jiang on 2021-06-07.
 */

import {WinPresentationController} from "../WinPresentationController";
import {ReelState} from "../../../core/reel/ReelState";
import {DeadwoodRip} from "../../DeadwoodRip";
import {DeadwoodRipStackedWild} from "../../symbol/DeadwoodRipStackedWild";
import {TimelineLite} from "gsap";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";

export class WildNudgeController extends WinPresentationController {

    private readonly _nudgeStepDuration:number = 0.3;
    private readonly _nudgeReelDelay:number = 0.2;
    private readonly _nudgeEase:string = `elastic.out(1, 1)`;

    private _startStepAnimations:(TimelineLite | null)[] = [];
    private _hasWin:boolean;

    constructor() {
        super("WildNudge", true);
    }

    protected hasWin():boolean {
        const data = DeadwoodRip.model.parsedGameData;
        if(data.nudgeSteps.some(s => s != 0)) {
            this._hasWin = data.betWins.length > 0 && data.singleWin > 0;
            return true;
        }
        return false;
    }

    protected async createWinAnimation():Promise<void> {
        DeadwoodRip.playScattersWin = true;
        const data = DeadwoodRip.model.parsedGameData;
        let delay = 0;
        const promises:Promise<void>[] = [];
        data.nudgeSteps.forEach((nudgeStep, reelId) => {
            if(nudgeStep != 0) {
                const promise = new Promise<void>(resolve => {
                        DeadwoodRip.reels[reelId].nudge(
                            nudgeStep,
                            this._hasWin ? this._nudgeStepDuration : 0.01,
                            this._nudgeEase,
                            delay,
                            (stepsLeft:number, aborted:boolean) => this.onNudgeStepStart(reelId, stepsLeft, aborted),
                            (stepsLeft:number, aborted:boolean) => this.onNudgeStepComplete(reelId, stepsLeft, aborted),
                            async (aborted:boolean) => {
                                await this.onReelNudgeComplete(reelId, aborted);
                                resolve();
                            },
                            false
                        );
                        delay += this._hasWin ? this.getNextReelNudgeDelayDelta(reelId) : 0.01;
                    }
                );
                promises.push(promise);
            }
        });
        // if(!this._hasWin && ArrayHelper.arraySum(DeadwoodRip.model.parsedGameData.nudgeSteps) > 0) {
        //     DeadwoodRipSound.soundPlayer.playTrack({name : "xnudgeInstant"});
        // }
        await Promise.all(promises);
    }

    protected skip() {
        let playAbortSound:boolean = false;
        DeadwoodRip.reels.forEach(reel => {
            if(reel.reelState === ReelState.NUDGE) {
                reel.abortNudge();
                playAbortSound = true;
            }
        });
        if(playAbortSound) {
            // playAbortSound();
        }
    }

    protected getNextReelNudgeDelayDelta(reelId:number):number {
        return Math.abs(DeadwoodRip.model.parsedGameData.nudgeSteps[reelId]) * this._nudgeStepDuration + this._nudgeReelDelay;
    }

    private onNudgeStepStart(reelId:number, stepsLeft:number, aborted:boolean):void {
        // Logger.logDev(`Reel ${reelId} start nudge step, stepsLeft = ${stepsLeft}, abort = ${aborted}`);

        if(Math.abs(stepsLeft) === 1) {
            DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.NUDGE_STEP_FINAL[reelId - 1]});
        } else if(this._hasWin && !aborted) {
            const stepIndex = Math.abs(DeadwoodRip.model.parsedGameData.nudgeSteps[reelId]) - Math.abs(stepsLeft);
            DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.NUDGE_STEP[stepIndex]});
        }

        const symId = stepsLeft > 0 ? 0 : 3;
        const w = <DeadwoodRipStackedWild>DeadwoodRip.reels[reelId].getSymbol(symId);
        if(!w.updateMultiplier) {
            throw new Error(`Nudge error on reelId ${reelId}, symId:${symId}, stepsLeft:${stepsLeft}, aborted:${aborted}`);
        }
        const tl = new TimelineLite();
        tl.add([
            w.updateMultiplier(w.currentMultiplier + 1, true),
            w.getNudgeAnimation(Math.abs(stepsLeft) === 1, aborted, this._hasWin)
        ]);
        this._startStepAnimations[reelId] = tl;
    }

    private onNudgeStepComplete(reelId:number, stepsLeft:number, aborted:boolean):void {
        // Logger.logDev(`Reel ${reelId} completed nudge step, stepsLeft = ${stepsLeft}, abort = ${aborted}`);
    }

    private async onReelNudgeComplete(reelId:number, aborted:boolean):Promise<any> {
        const tl = this._startStepAnimations[reelId];
        if(tl && tl.totalDuration() > 0) {
            await Promise.resolve(tl);
        } else {
            await Promise.resolve();
        }
        this._startStepAnimations[reelId] = null;
        // Logger.logDev(`Reel ${reelId} completed reel nudge, abort = ${aborted}`);
    }
}